module.exports = __webpack_public_path__ + "static/media/4p.beea0d64.jpg";